<script lang="ts">
	import { clickOutside } from '$lib/actions/click-outside';
	import { Card, Modal } from '$lib/components';

	type Props = {
		title: string;
		text: string;
	};
	let { title, text }: Props = $props();
	let index = $state(0);
</script>

<div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
	<!-- eslint-disable-next-line @typescript-eslint/no-unused-vars -->
	{#each Array.from({ length: 3 }) as _, i (i)}
		<button
			type="button"
			aria-label="Show current image in higher resolution"
			class="rounded-base overflow-hidden"
			onclick={() => (index = i + 1)}
		>
			<picture>
				<source
					srcset="/img/fleet/fleet{i + 1}-md.avif"
					type="image/avif"
					width="500"
					height="677"
				/>
				<source
					srcset="/img/fleet/fleet{i + 1}-md.webp"
					type="image/webp"
					width="500"
					height="677"
				/>
				<img
					src="/img/fleet/fleet{i + 1}-md.jpg"
					alt="Private Taxi and Shuttle Shared Service"
					width="500"
					height="677"
					class="w-full h-full object-cover"
				/>
			</picture>
		</button>
	{/each}
</div>
<Card className="text-center text-lg">
	<h3 class="text-2xl font-semibold mb-3 gradient">
		{title}
	</h3>
	<p>
		{text}
	</p>
</Card>
{#if index}
	<Modal className="max-w-5xl">
		<div use:clickOutside onclickoutside={() => (index = 0)}>
			<button
				type="button"
				aria-label="Close image"
				class="relative rounded-base shadow-2xl overflow-hidden"
				onclick={() => (index = 0)}
			>
				<img src="/img/fleet/fleet{index}.jpg" alt="Fleet" height={675} width={1200} />
			</button>
		</div>
	</Modal>
{/if}
